import styled from 'styled-components';
import { Text } from '@appcues/sonar';

export const FilterOptions = styled.div`
  max-height: 250px;
  overflow-y: auto;

  [role='menuitem'] {
    max-width: 260px;
  }
`;

export const SearchWrapper = styled.div`
  padding: var(--spacing-regular);
`;

export const NoResultsFound = styled(Text)`
  padding: var(--spacing-small) var(--spacing-regular) var(--spacing-regular)
    var(--spacing-regular);
  text-align: center;
`;
